/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetRecommendedDiets200
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type get_recommended_dietsResponse200 = {
  data: GetRecommendedDiets200
  status: 200
}

export type get_recommended_dietsResponseSuccess = (get_recommended_dietsResponse200) & {
  headers: Headers;
};
;

export type get_recommended_dietsResponse = (get_recommended_dietsResponseSuccess)

export const getGetRecommendedDietsUrl = () => {




  return `/api/recommended-diets`
}

/**
 * Returns up to three recommended search result items for each configured recommendation tag.
 * @summary Get recommended diets grouped by tag.
 */
export const get_recommended_diets = async ( options?: RequestInit): Promise<get_recommended_dietsResponse> => {

  return apiCatalog<get_recommended_dietsResponse>(getGetRecommendedDietsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecommendedDietsQueryKey = () => {
    return [
    `/api/recommended-diets`
    ] as const;
    }


export const getGetRecommendedDietsQueryOptions = <TData = Awaited<ReturnType<typeof get_recommended_diets>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_recommended_diets>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecommendedDietsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_recommended_diets>>> = ({ signal }) => get_recommended_diets({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_recommended_diets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRecommendedDietsQueryResult = NonNullable<Awaited<ReturnType<typeof get_recommended_diets>>>
export type GetRecommendedDietsQueryError = unknown


export function useGetRecommendedDiets<TData = Awaited<ReturnType<typeof get_recommended_diets>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_recommended_diets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_recommended_diets>>,
          TError,
          Awaited<ReturnType<typeof get_recommended_diets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecommendedDiets<TData = Awaited<ReturnType<typeof get_recommended_diets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_recommended_diets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_recommended_diets>>,
          TError,
          Awaited<ReturnType<typeof get_recommended_diets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecommendedDiets<TData = Awaited<ReturnType<typeof get_recommended_diets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_recommended_diets>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get recommended diets grouped by tag.
 */

export function useGetRecommendedDiets<TData = Awaited<ReturnType<typeof get_recommended_diets>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_recommended_diets>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRecommendedDietsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






